import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth'
import { trackPage } from '../../analytics'

import styles from './ProfileDialog.module.css'

const settings = [
  {
    name: 'Subscription',
    path: '/subscription'
  },
  {
    name: 'Redeem Voucher',
    path: '/voucher'
  },
  {
    name: 'My History',
    path: '/history'
  }
]

const ProfileDialog = () => {
  const auth = useSelector(state => state.auth)
  const dispatch = useDispatch()
  const user = auth.user

  useEffect(() => {
    trackPage('Profile')
  }, [])

  if (!user) {
    return null
  }

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <div className={styles['profile-wrapper']}>
      <p className={styles['profile-name']}>
        {user.account.name || user.account.username}
      </p>
      <p className={styles['profile-email']}>{user.account.email}</p>
      <div className={styles['profile-settings']}>
        {settings.map(item => {
          return (
            <Link to={item.path} key={item.path}>
              <p>{item.name}</p>
            </Link>
          )
        })}
      </div>
      <p className={styles['logout']} onClick={handleLogout}>
        Log out
      </p>
    </div>
  )
}

export default ProfileDialog
